import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\GravePlot\GetGravePlotController::__invoke
* @see app/Http/Controllers/GravePlot/GetGravePlotController.php
* @route '/api/grave-plot/{grave_plot}'
*/
const GetGravePlotController = (args: { grave_plot: string | number | { id: string | number } } | [grave_plot: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetGravePlotController.url(args, options),
    method: 'get',
})

GetGravePlotController.definition = {
    methods: ["get","head"],
    url: '/api/grave-plot/{grave_plot}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\GravePlot\GetGravePlotController::__invoke
* @see app/Http/Controllers/GravePlot/GetGravePlotController.php
* @route '/api/grave-plot/{grave_plot}'
*/
GetGravePlotController.url = (args: { grave_plot: string | number | { id: string | number } } | [grave_plot: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { grave_plot: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { grave_plot: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            grave_plot: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        grave_plot: typeof args.grave_plot === 'object'
        ? args.grave_plot.id
        : args.grave_plot,
    }

    return GetGravePlotController.definition.url
            .replace('{grave_plot}', parsedArgs.grave_plot.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\GravePlot\GetGravePlotController::__invoke
* @see app/Http/Controllers/GravePlot/GetGravePlotController.php
* @route '/api/grave-plot/{grave_plot}'
*/
GetGravePlotController.get = (args: { grave_plot: string | number | { id: string | number } } | [grave_plot: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetGravePlotController.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\GravePlot\GetGravePlotController::__invoke
* @see app/Http/Controllers/GravePlot/GetGravePlotController.php
* @route '/api/grave-plot/{grave_plot}'
*/
GetGravePlotController.head = (args: { grave_plot: string | number | { id: string | number } } | [grave_plot: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetGravePlotController.url(args, options),
    method: 'head',
})

export default GetGravePlotController